import React from 'react'
import Moment from 'react-moment'
import { useDispatch } from 'react-redux'
import { Box } from '@mui/material'
import { Modal } from '../dialog'
import { useReduxSelector } from '../../hooks'
import { GreetingsClose } from '../../store/greetings'

const greetingsModalName = 'greetingsModal'

export const Greetings: React.FC = (): JSX.Element => {
  const dispatch = useDispatch()
  const { data: constants } = useReduxSelector((state) => state.constants)
  const { status: show, stopAction: statusAction } = useReduxSelector((state) => state.greetings)

  const onClose = () => {
    dispatch(GreetingsClose(statusAction))
  }

  return (
    <Modal open={show} maxWidth="sm" title="Информация" name={greetingsModalName} onClose={onClose}>
      {statusAction && (
        <Box textAlign="center" my={2} lineHeight={1.3}>
          Уважаемые участники!
          <br />
          Регистрация в&nbsp;акции завершена
          <br />
          <Moment format="DD MMMM YYYY года.">{constants?.PROJECT_STOP_ACTION}</Moment>
        </Box>
      )}
    </Modal>
  )
}
